var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// function tryCatchYield<T, TNext>(value: T): Generator<T, [TNext, false]>;
// function tryCatchYield<T, TNext>(value: T): Generator<T, [any, true]>;
function tryCatchYield(value) {
    var e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, value];
            case 1: return [2 /*return*/, [_a.sent(), false]];
            case 2:
                e_1 = _a.sent();
                return [2 /*return*/, [e_1, true]];
            case 3: return [2 /*return*/];
        }
    });
}
/**
 * Executes the generator, and passes each yielded value to a `stopCondition`
 * function which determine if the generator should be early terminated.
 *
 * @param {Generator} generator
 * @param {Function} stopCondition Given the yielded value, determines if should stop the generator execution.
 *
 * @returns {Generator}
 */
export function runGenerator(generator, stopCondition) {
    var yielded, error, _a, nextValue, isError;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                yielded = generator.next();
                _b.label = 1;
            case 1:
                if (!!yielded.done) return [3 /*break*/, 3];
                if (stopCondition(yielded.value)) {
                    error = new Error('RetryError');
                    error.yielded = yielded.value;
                    throw error;
                }
                return [5 /*yield**/, __values(tryCatchYield(yielded.value))];
            case 2:
                _a = __read.apply(void 0, [_b.sent(), 2]), nextValue = _a[0], isError = _a[1];
                if (isError) {
                    yielded = generator.throw(nextValue);
                }
                else {
                    yielded = generator.next(nextValue);
                }
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/, yielded.value];
        }
    });
}
export function actionTypeMatches(regex) {
    return function matches(value) {
        var _a, _b;
        return (value === null || value === void 0 ? void 0 : value.type) === 'PUT' && regex.test((_b = (_a = value.payload) === null || _a === void 0 ? void 0 : _a.action) === null || _b === void 0 ? void 0 : _b.type);
    };
}
export var alwaysFalse = function () { return false; };
//# sourceMappingURL=utils.js.map